import { BaseApi } from './base.api.js';

// LEGACY-BYPASS: LB-20260720-01 — legacy IntegrationConnector SDK kept until ITSM consumers move to IntegrationConnection
export class IntegrationConnectorApi extends BaseApi {
    constructor(client) {
        super(client, '/integration-connector');
    }
}
